import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { GstFormComponent } from "./gst-form/gst-form.component";
import { GstListComponent } from "./gst-list/gst-list.component";

const routes:Routes=[
    {
        path:'',
        data:{
            title:'Gst'
        },
        component:GstListComponent
    },
    {
        path:'add',
        data:{
            title:'Add Gst'
        },
        component:GstFormComponent
    },
    {
        path:'edit/:id',
        data:{
            title:'Edit Gst'
        },
        component:GstFormComponent
    }
]



@NgModule({
    imports:[ RouterModule.forChild(routes) ],
    exports:[RouterModule]
})
export class GstRoutingModule{

}